import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getContactsList, getContactsFilter } from "../helpers/backend";
import PaginationTest from "./PaginationTest";
import { useSelector } from "react-redux";

const ContactsSelect = (props) => {
  const {
    isMulti = false,
    isDisabled = false,
    value = null,
    onContactSelect,
    showPhone = true, // Por defecto muestra el teléfono
    placeholder = "Seleccione contactos",
    disableConditions = false, // Condiciones adicionales para deshabilitar
    color = false
  } = props;

  const [contacts, setContacts] = useState([]);
  const [contactsFull, setContactsFull] = useState([]);
  const [next, setNext] = useState(null);
  const [inputSearch, setInputSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [triggerPagination, setTriggerPagination] = useState(false);

  const getContactData = async () => {
    try {
      const response = await getContactsList();
      setContacts(response.data.results);
      setNext(response.data.next);
    } catch (error) {
      console.error("Error al obtener los contactos:", error);
    }
  };

  const handleFilter = async (params) => {
    try {
      const response = await getContactsFilter(params);
      if (response && response.data) {
        setContacts(response.data.results);
        setNext(response.data.next);
        setTriggerPagination(false);
      }
    } catch (error) {
      console.error("Error en handleFilter:", error);
    }
  };

  const onSearch = (searchTerm) => {
    setInputSearch(true);
    setSearchTerm(searchTerm);
    handleFilter({ changeUrl: `?search=${searchTerm}` });
  };

  useEffect(() => {
    getContactData();
  }, []);

  useEffect(() => {
    if (Array.isArray(contacts) && !inputSearch) {
      setContactsFull((prevContacts) => [
        ...prevContacts,
        ...contacts.filter(
          (contact) => !prevContacts.some((c) => c.id === contact.id)
        ),
      ]);
    }
    if (inputSearch) {
      setContactsFull(contacts);
    }
  }, [contacts, inputSearch]);

  // Función para formatear el label mostrando teléfono y nombre
  const formatOptionLabel = (contact) => {
    if (showPhone) {
      const phone = contact.phone && contact.phone[0] ? contact.phone[0].telefono : '';
      return `${phone} - ${contact.get_full_name}`;
    }
    return contact.get_full_name;
  };

  // Función para encontrar el valor seleccionado actual
  const getCurrentValue = () => {
    if (!value) return null;
    
    if (isMulti) {
      return contactsFull
        .filter(contact => value.includes(contact.id))
        .map(contact => ({
          value: contact.id,
          label: formatOptionLabel(contact)
        }));
    } else {
      const contact = contactsFull.find(c => c.id === value);
      return contact ? {
        value: contact.id,
        label: formatOptionLabel(contact)
      } : null;
    }
  };

  const theme = useSelector((state) => state.theme.theme) || "light";

  return (
    <React.Fragment>
      {triggerPagination && next && (
        <PaginationTest
          next={next}
          filterFunction={handleFilter}
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
        />
      )}
      <Select
        options={
          contactsFull &&
          contactsFull.map((item) => ({
            label: formatOptionLabel(item),
            value: item.id,
          }))
        }
        isMulti={isMulti}
        isDisabled={isDisabled || disableConditions} // Combina ambas condiciones
        value={getCurrentValue()}
        placeholder={placeholder}
        onMenuScrollToBottom={() => {
          setTriggerPagination(true);
        }}
        menuPlacement="auto"
        onChange={(selectedOptions) => {
          let selectedValues;

          if (isMulti) {
            selectedValues = selectedOptions.map((option) => option.value);
          } else {
            selectedValues = selectedOptions ? selectedOptions.value : null;
          }

          if (onContactSelect) {
            onContactSelect(selectedValues);
          }
        }}
        onInputChange={(inputValue) => {
          onSearch(inputValue);
          if (inputValue === "") {
            setInputSearch(false);
          } else {
            setInputSearch(true);
          }
        }}
        menuPosition="fixed"
        className="flex-grow-1"
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor:
              color && theme === "dark"
                ? "#3b3b3b"
                : !color && theme === "dark"
                ? "#242424"
                : "#fff",
            color: theme === "dark" ? "#c3cbe4" : "#000",
            borderColor:
              color && theme === "dark"
                ? "#4f4f4f"
                : !color && theme === "dark"
                ? "#3b3b3b"
                : "#d2d2d2",
            cursor: "pointer",
            fontSize: "0.9rem",
          }),
          menu: (base) => ({
            ...base,
            backgroundColor: theme === "dark" ? "#242424" : "#fff",
            borderRadius: "8px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          }),
          option: (base, { isFocused, isSelected }) => ({
            ...base,
            backgroundColor: isSelected
              ? theme === "dark"
                ? "#242424"
                : "#ccc"
              : isFocused
              ? theme === "dark"
                ? "#121212"
                : "#ddd"
              : "transparent",
            color: theme === "dark" ? "#c3cbe4" : "#000",
            padding: "10px",
            fontSize: "0.9rem",
            cursor: "pointer",
          }),
          singleValue: (base) => ({
            ...base,
            color: theme === "dark" ? "#c3cbe4" : "#000",
          }),
        }}
      />
    </React.Fragment>
  );
};

export default ContactsSelect;